module.exports = __webpack_public_path__ + "img/128.33c78eac.jpg";